import { useEffect } from 'react';
import { useGlobalContext } from '../components/GlobalContextProvider/GlobalContextProvider';
import useBreadcrumbsScrollFix from './useBreadcrumbsScrollFix';

const HEADER_HEIGHT = '-72px';

const useBreadcrumbsNav = (titleRef) => {
  const { headerRef, setPercentOfCoveredTitle } = useGlobalContext();

  useBreadcrumbsScrollFix();

  useEffect(() => {
    if (!titleRef.current) return;

    const cachedTitle = titleRef.current;

    const observer = new IntersectionObserver(
      ([e]) => {
        setPercentOfCoveredTitle(e.intersectionRatio);
      },
      {
        root: headerRef,
        threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
        rootMargin: HEADER_HEIGHT,
      },
    );

    observer.observe(cachedTitle);
    return () => observer.unobserve(cachedTitle);
  }, [titleRef]);
};

export default useBreadcrumbsNav;
